export default "__VITE_ASSET__MV5gu$gU__"